import { Component, Input, OnInit, HostBinding } from '@angular/core';
import { OnyxEvent } from '../models/event';
import { EventStore } from '../service/event.store';
import { ReservationCompareStore } from 'app/event/service/reservation-compare-store';
import { Observable } from 'rxjs/Observable';
import { MatchTypeEnum } from '../models/match-type.enum';
import { ReservationUtils } from '../utils/reservation-utils';
import { ActivatedRoute } from '@angular/router';
import { RouteUtils } from '../utils/route-utils';

@Component({
  selector: 'pioneer-event-nav',
  templateUrl: 'event-nav.component.html'
})
export class EventNavComponent implements OnInit {

  @HostBinding('class') classes = 'margin-content';
  @HostBinding('id') elementId = 'scrollSpyId';

  public onyxEvent: OnyxEvent;

  public MatchTypeEnum = MatchTypeEnum;

  constructor(private eventStore: EventStore,
              private reservationCompareStore: ReservationCompareStore,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.onyxEvent = new OnyxEvent();
    this.eventStore.selectedEvent.subscribe(value => {
      this.onyxEvent = new OnyxEvent(value);
    });
  }

  getReservationSummarySelected(): Observable<boolean> {
    return this.reservationCompareStore.getShowReservationSummary();
  }

  isFilteredMatchListEmpty(matchType: MatchTypeEnum): Observable<boolean> {
    return this.reservationCompareStore.isFilteredMatchListEmpty(matchType);
  }

  shouldShowMatchTypeLink(matchType: MatchTypeEnum): Observable<boolean> {
    return this.reservationCompareStore.isMatchListEmpty(matchType).map(result => !result);
  }

  getContractSummaryRouterLink(): string[] {
    const lastSegment = RouteUtils.getLastUrlSegmentSnapshot(this.route);

    if (lastSegment && lastSegment.path === 'edit') {
      return ['/event/' + this.onyxEvent.eventId + '/edit'];
    } else {
      return ['/event/' + this.onyxEvent.eventId];
    }
  }

  getNoMatchNavTitle(): Observable<string> {
    return ReservationUtils.getNumberOfRsvps(this.reservationCompareStore.getReservationList()).map(size => {
      return size > 0 ? 'EVENT.RESERVATION.NO_MATCH_TITLE' : 'EVENT.RESERVATION.NO_RSVP_TITLE';
    });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/event-nav/event-nav.component.ts